<h2 mat-dialog-title>{{ 'TRACEABILITY.PRINT.LABEL' | translate }}</h2>
<mat-dialog-content *ngIf="exercise?.categories; let categories">
  <form class="aio-print-content">
    <!-- List of options -->
    <ul [formGroup]="columns" class="aio-print-content-list">
      <li><mat-label>{{ 'TRACEABILITY.PRINT.COLUMNS' | translate }} :</mat-label></li>
      <li>
        <!-- Primary categories -->
        <div *ngFor="let columnName of categories[0]">
          <mat-checkbox [formControlName]="columnName">
            {{ columnName | translate}}
          </mat-checkbox>
        </div>

        <!-- Expedition category -->
        <div>
          <mat-checkbox formControlName="EXP">
            {{ 'EXP' | translate}}
          </mat-checkbox>
        </div>
      </li>
      <br/>
    </ul>
    <ul [formGroup]="typologies" class="aio-print-content-list">
      <li><mat-label *ngIf="categories[1]?.length > 0">{{ 'TRACEABILITY.PRINT.TYPOLOGIES' | translate }} :</mat-label></li>
      <li>

        <!-- Secondary categories -->
        <div *ngFor="let typology of categories[1]">
          <mat-checkbox [formControlName]="typology">
            {{ typology | translate}}
          </mat-checkbox>
        </div>
      </li>
    </ul>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="accent" mat-flat-button (click)="print()">
    {{ 'DIALOG.OK' | translate }}
  </button>
</mat-dialog-actions>